module.exports = __webpack_public_path__ + "static/img/img_shici.9ecc13a.9ecc13a2.jpg";